import React from 'react'
import CardUI from '../../widgets/layout/CardUI'
import FormSF from '../../widgets/form/FormSF'
import InputTextSF from '../../widgets/form/InputTextSF'
import ButtonLinkUI from '../../widgets/action/ButtonLinkUI'
import InputPhoneNumberUI from '../../widgets/form/InputPhoneNumberUI'

const LoginWithPhoneUI = ({ context, messageList, onSubmit, submitted, successMsg, errorList, setErrorList,
  phoneNumber, onPhoneNumberChange, phoneNumberError, setPhoneNumberError,
  pinCode, onPinCodeChange, pinCodeError, setPinCodeError
}) =>
  <CardUI context={context}>
    <FormSF context={context} messageList={messageList}
      buttonMessageKey='c_login'
      onSubmit={onSubmit} successMsg={successMsg} errorList={errorList} setErrorList={setErrorList}
      busy={submitted}>
      <InputPhoneNumberUI name='phoneNumber' required={true}
        messageList={messageList} labelKey='c_phone_number'
        value={phoneNumber} onChange={onPhoneNumberChange}
        error={phoneNumberError} setError={setPhoneNumberError}
        autoFocus={true}
      />
      <InputTextSF type='password' name='pinCode' required={true} maxLength={8}
        messageList={messageList} labelKey='c_pin_code'
        value={pinCode} onChange={onPinCodeChange}
        error={pinCodeError} setError={setPinCodeError}
      />
    </FormSF>

    <div className='passwd'>
      <ButtonLinkUI context={context} messageList={messageList} labelKey='c_forgot_pincode_help'
        to={`/pub/pincode-reset`} transparent={true}
      />
    </div>
  </CardUI>

export default LoginWithPhoneUI
